import React from 'react';
import { formatRelativeDate } from '../../common/lib/formatDate';
import type { JobAd } from '../../types';
import { useSearchAdContext } from '../search/SearchAdContext';

type LegendaryJobDateLocationProps = {
    ad: JobAd;
    className?: string;
};

export function LegendaryJobDateLocation(props: LegendaryJobDateLocationProps) {
    const { ad, className } = props;

    const { currentTime } = useSearchAdContext();

    const deadlineLabel = ad.labels
        ?.filter((label) => label.type === 'PRIMARY')
        .find((label) => label.id === 'siste_frist');
    const isDeadLineToday = Boolean(deadlineLabel);

    const dateLocationFormatted = getDateLocation(ad, {
        currentTime,
        isDeadLineToday,
    });

    return <div className={className}>{dateLocationFormatted}</div>;
}

function getDateLocation(
    ad: JobAd,
    {
        currentTime,
        isDeadLineToday = false,
    }: { currentTime?: number; isDeadLineToday?: boolean } = {},
) {
    if (isDeadLineToday) {
        return ad.location ?? '';
    }

    const publishedDate = formatRelativeDate(ad.timestamp, {
        currentTime,
        newTodayText: true,
    });

    if (ad.location) {
        return publishedDate + ' | ' + ad.location;
    }

    return publishedDate;
}
